import { render, staticRenderFns } from "./error-list.vue?vue&type=template&id=36aa1c23&scoped=true&"
import script from "./error-list.vue?vue&type=script&lang=js&"
export * from "./error-list.vue?vue&type=script&lang=js&"
import style0 from "./error-list.vue?vue&type=style&index=0&id=36aa1c23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa1c23",
  null
  
)

export default component.exports